import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[[PHGPostHog sharedPostHog] capture:@"user signed up"];
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`posthog.capture("user signed up")
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[[PHGPostHog sharedPostHog] capture:@"user signed up" 
    properties:@{ @"login_type": @"email", 
                  @"$is_free_trial": @YES }
];
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`posthog.capture(
    "user signed up", 
    properties: ["login_type": "email", "$set": ["is_free_trial": true] 
])
`}</code></pre>
    <h3 {...{
      "id": "capturing-screen-views"
    }}>{`Capturing screen views`}</h3>
    <p>{`With `}<a parentName="p" {...{
        "href": "/ios#all-configuration-options"
      }}><inlineCode parentName="a">{`configuration.recordScreenViews`}</inlineCode></a>{` set as `}<inlineCode parentName="p">{`YES`}</inlineCode>{`, PostHog will try to record all screen changes automatically.`}</p>
    <p>{`If you want to manually send a new screen capture event, use the `}<inlineCode parentName="p">{`screen`}</inlineCode>{` function.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[[PHGPostHog sharedPostHog] screen:@"Dashboard" properties:@{ @"fromIcon": @"bottom" }];
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`posthog.screen("Dashboard", properties: ["fromIcon": "bottom"])
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      